import React, { useState } from 'react';
import { Row, Col, Form, Button, Table } from 'react-bootstrap';
import { FaPlus, FaTrash } from 'react-icons/fa';

// W-0743 — Grid editável de tipo de logradouro (ADR-005). Estado in-memory (não persiste).
// Mostra o SEED (read-only, precedência) + os pares custom adicionados pelo usuário. Labels "De"/"Para".
// Fonte: UAtuCadPref.pas:1628-1642 (seed) + DBGrid3/btIncluir (DFM:587-657).
const SEED = [
  { tipo1: 'Rua ', tipo2: 'Rua' },
  { tipo1: ' Rua ', tipo2: 'Rua' },
  { tipo1: 'R ', tipo2: 'Rua' },
  { tipo1: 'Rua: ', tipo2: 'Rua' },
  { tipo1: 'Avenida ', tipo2: 'Avenida' },
  { tipo1: ' Avenida ', tipo2: 'Avenida' },
  { tipo1: 'Av ', tipo2: 'Avenida' },
  { tipo1: 'Av. ', tipo2: 'Avenida' },
  { tipo1: ' Av ', tipo2: 'Avenida' },
  { tipo1: 'Travessa ', tipo2: 'Travessa' },
  { tipo1: ' Travessa ', tipo2: 'Travessa' },
  { tipo1: 'Alameda ', tipo2: 'Alameda' },
  { tipo1: ' Alameda ', tipo2: 'Alameda' },
  { tipo1: 'Al. ', tipo2: 'Alameda' },
  { tipo1: ' Al. ', tipo2: 'Alameda' },
];

const GridTipoLogradouro = ({ custom, onChange }) => {
  const [de, setDe] = useState('');
  const [para, setPara] = useState('');

  const incluir = () => {
    const d = de.trim();
    const p = para.trim();
    if (!d || !p) return;
    onChange([...custom, { tipo1: d, tipo2: p }]);
    setDe('');
    setPara('');
  };

  const remover = (idx) => {
    const novo = custom.filter((_, i) => i !== idx);
    onChange(novo);
  };

  return (
    <div className="mt-2">
      <Form.Label className="font-weight-bold mb-1">
        Tipos de Logradouro (De → Para)
      </Form.Label>
      <Row className="mb-2 align-items-end">
        <Col md={4}>
          <Form.Label className="mb-1">De</Form.Label>
          <Form.Control
            size="sm"
            value={de}
            placeholder="Ex.: Estrada "
            onChange={(e) => setDe(e.target.value)}
          />
        </Col>
        <Col md={4}>
          <Form.Label className="mb-1">Para</Form.Label>
          <Form.Control
            size="sm"
            value={para}
            placeholder="Ex.: Estrada"
            onChange={(e) => setPara(e.target.value)}
          />
        </Col>
        <Col md={4}>
          <Button variant="outline-primary" size="sm" onClick={incluir}>
            <FaPlus className="mr-1" />
            Incluir
          </Button>
        </Col>
      </Row>

      <Table striped bordered hover size="sm" className="mb-0">
        <thead>
          <tr>
            <th>De</th>
            <th>Para</th>
            <th style={{ width: 80 }}>Origem</th>
          </tr>
        </thead>
        <tbody>
          {SEED.map((s) => (
            <tr key={`seed-${s.tipo1}`} className="text-muted">
              <td>{s.tipo1}</td>
              <td>{s.tipo2}</td>
              <td>Padrão</td>
            </tr>
          ))}
          {custom.map((c, idx) => (
            <tr key={`custom-${c.tipo1}-${idx}`}>
              <td>{c.tipo1}</td>
              <td>{c.tipo2}</td>
              <td>
                <Button
                  variant="link"
                  size="sm"
                  className="p-0 text-danger"
                  onClick={() => remover(idx)}
                  title="Remover"
                >
                  <FaTrash />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <small className="text-muted">
        Os padrões têm precedência; os mapeamentos custom valem para prefixos não cobertos.
      </small>
    </div>
  );
};

export default GridTipoLogradouro;
